import React, { useEffect, useState, useRef } from "react";
import ReactExport from "react-export-excel";
import { Button } from "antd";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;


const Excelldownload = ({ data, data1 }) => {
  return (
    <ExcelFile element={<Button type="ghost" style={{ width: "100%", marginLeft: "2px",backgroundColor:"green",color:"white" }}>Excel</Button>}>
      <ExcelSheet data={data} name="All Invoices">
        <ExcelColumn label="Date" value="issue_date" />
        <ExcelColumn label="Invoice No." value="invoice_number" />
        <ExcelColumn label="Order No." value="order_number" />
        <ExcelColumn label="Status" value="status" />
        <ExcelColumn label="Remarks" value="remarks" />
        {/* <ExcelColumn
          label="Remarks"
          value={(col) => (
            <div
              className="d-div"
              dangerouslySetInnerHTML={{ __html: col.remarks }}
            ></div>
          )}
        /> */}
        
        <ExcelColumn label="Product Disc" value={(details) => (
          parseFloat(details.additional_discount) + parseFloat(details.spec_item_discount)
        )} />
        <ExcelColumn label="Sales Disc" value="discount" />
        <ExcelColumn label="Bill" value="bill" />
        {/* <ExcelColumn label="Payment" value="payment" /> */}
        <ExcelColumn label="Due" value="due" />
        {/* <ExcelColumn label="Payment method" value="Payment_method" /> */}
        {/* <ExcelColumn label="Delivery date" value="delivery_date" />
        <ExcelColumn label="Delivery method" value="delivery_method" />
        <ExcelColumn label="Delivery cost" value="delivery_cost" />

        <ExcelColumn label="Account no." value="Account_no" />
        <ExcelColumn label="Transection" value="Transection_no" /> */}
      </ExcelSheet>
      
    </ExcelFile>
  );
};

export default Excelldownload;
